import { getResourceLifecycleStatus, stateT, Status, useNavigation } from "o4a-react";
import * as React from "react";
import { NormalError } from "savant-connector";
import { Link, Shimmer } from "@fluentui/react";
import { ConsoleContext } from "../../console/ConsoleContext";
import { RESOURCE_ROUTE } from "../../constants/pluginConstants";
import { emptyChar } from "../../constants/uiConstants";
import { LinkAnalyticsData, useAnalytics } from "../../hooks/useAnalytics";

export interface Resource {
  id: string | undefined;
  name: string | undefined;
  location: string | undefined;
  status?: string ;
}

export interface ResourceNavigation {
  navigationKey: string;
  panelPath: string | undefined;
}

export interface CustomNavigation {
  onClick: () => void;
}

export interface ResourceLinkProps<T extends Resource> {
  resource: T;
  navigation: ResourceNavigation | CustomNavigation;
  analytics: LinkAnalyticsData;
  error: NormalError | undefined;
  loading: boolean;
}

// eslint-disable-next-line react/function-component-definition
export function ResourceLink<T extends Resource>({
  resource,
  navigation,
  analytics,
  error,
  loading,
}: ResourceLinkProps<T>): JSX.Element {
  const { trackLinkNavigate } = useAnalytics();

  const { navigateTo } = useNavigation(ConsoleContext);

  const isLoading = (loading && !resource) && !error;

  return (
    <Shimmer
      isDataLoaded={!isLoading}
      width="50%"
    >
      {(error || !resource?.id) && emptyChar}
      {!error && resource?.id && (
        <span style={{ display: "flex" }}>
          <Link
            onClick={() => {
              trackLinkNavigate(analytics.target, analytics.source.pageId, analytics.source.panelId);
              if ("onClick" in navigation) {
                navigation.onClick();
              } else if ("navigationKey" in navigation) {
                navigateTo(
                  `${RESOURCE_ROUTE}/${resource?.id}/${navigation.panelPath}?location=${resource?.location}`,
                  navigation.navigationKey,
                );
              }
            }}
          >
            {resource?.name}
          </Link>
          {resource?.status && (
            <div style={{ marginLeft: "6px" }}>
              <Status
                status={getResourceLifecycleStatus(resource.status)}
                tooltip={stateT(resource.status)}
              />
            </div>
          )}
        </span>
      )}
    </Shimmer>
  );
}
